import Column from '@components/Column';
import { Link } from '@router/Link';

import AllIcon from './AllIcon';
import styles from './styles.module.scss';

function AllButton() {
    return (
        <Link activityName='MyMenuActivity'
            activityParams={{}}>
            <Column spacing={6} align='center'>
                <AllIcon className={styles.icon}/>
                <button className={styles.button}>
                    전체보기
                </button>
            </Column>
        </Link>
    );
}

export default AllButton;
